import { useEffect } from 'react';

type DocsAuthenticationRedirectProps = {
  slug: string;
};

const DocsAuthenticationRedirect: React.FC<DocsAuthenticationRedirectProps> = ({ slug }) => {
  useEffect(() => {
    const form = document.getElementById('redirectForm') as HTMLFormElement;
    form.submit();
  }, []);

  return (
    <form id="redirectForm" method="post" action="https://api-reference.vopay.com/password" style={{ display: 'none' }}>
      <input type="hidden" name="password" value="password1234" />
      <input type="hidden" name="redirect" value={slug} />
    </form>
  );
};

export default DocsAuthenticationRedirect;
